import { Injectable } from '@angular/core';
import { CustomRule, Filter } from '../../models/filter-models';
import { Comparator, Rarity } from "../../models/enums";
import { EquipmentType } from '../../models/equipment-type.enum';
import { RuleGeneratorService } from './rule-generator.service';

@Injectable({
  providedIn: 'root'
})
export class PoE2WaystoneGeneratorService {
  constructor(
    private ruleGeneratorService: RuleGeneratorService
  ) { }

  public generatePoE2WaystoneRules(filter: Filter) {
    const rareStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.ItemsWaystonesRare, new CustomRule({
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Rare,
    }), filter, 'Rare Waystones', { customBaseTypes: '"Waystone"' }, undefined, filter.showRareWaystones);

    // const deliriumStyle = filter.showDeliriumWaystones ? this.ruleGeneratorService.generateEquipmentRule(EquipmentType.ItemsWaystonesDelirium, new CustomRule({
    //   rarity: Rarity.Rare,
    //   rarityComparator: Comparator.LessThanOrEqual,
    //   advancedConditions: new AdvancedConditions({ anyEnchantment: true }),
    // }), filter, 'Delirium Waystones', { customBaseTypes: '"Waystone"' }) : '';

    const otherStyle = this.ruleGeneratorService.generateEquipmentRule(EquipmentType.ItemsWaystonesOther, new CustomRule({
      rarityComparator: Comparator.LessThanOrEqual,
      rarity: Rarity.Magic,
    }), filter, 'Other Waystones', { customBaseTypes: '"Waystone"' }, undefined, filter.showOtherWaystones);

    return rareStyle + '\n' + otherStyle + '\n';
  }
}
